import { GzInputTextGridWebComponent } from './component/GzInputTextGridWebComponent';

export { GzInputTextGridWebComponent };
